import { render, staticRenderFns } from "./CategoryActionMassDelete.vue?vue&type=template&id=75dfcd08&"
import script from "./CategoryActionMassDelete.vue?vue&type=script&lang=ts&"
export * from "./CategoryActionMassDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports